export default {
  storeTo: 'Almacén de destino',
  weightHaveUnit: 'Peso (g)',
  productType: 'Categoría del artículo',
  long: 'Longitud (cm)',
  width: 'Ancho (cm)',
  height: 'Altura (cm)',
  seeDetail: 'Ver detalles',
  queryTips: 'Por favor, ingrese los parámetros correspondientes para consultar el costo de envío!',
  carrier: 'Transportista',
  carrierCode: 'Código del transportista',
  product: 'Producto',
  productCode: 'Código del producto',
  totalfee: 'Costo total',
  billingWeight: 'Peso facturado',
  feeEstimation: 'Estimación del costo',
  postFeeEstimation: 'Estimación del costo de envío',
  postFee: 'Costo de envío',
  postTime: 'Tiempo estimado de envío',
  packUp: 'Colapsar',
  startWeight: 'Peso inicial',
  endWeight: 'Peso final',
  calcExpression: 'Expresión de cálculo',
  baseFreight: 'Flete base',
  registrationFee: 'Tarifa de registro',
  noSend: 'Productos no disponibles',
  canSend: 'Productos disponibles',
  priceFrom: 'Composición del costo',
  itemLimit: 'Límite de artículos',
  disReason: 'Razón de no disponibilidad',
  BasicFreight: 'Flete básico',
  OperationFreight: 'Gastos de aduana',
  RegistrationFreight: 'Tarifa de registro',
  IossFee: 'Tarifa IOSS',
  TariffFreight: 'Tarifa arancelaria',
  VATFregith: 'Tarifa del Impuesto al Valor Agregado (IVA)',
  AserviceFee: 'Tarifa de servicio adicional',
  ExtraSizeFreight: 'Recargo por tamaño extra',
  AdditionalDeliveryFeeForFemoteAreas: 'Tarifa adicional de entrega para zonas remotas',
  FuelSurcharge: 'Recargo por combustible',
  zoneCode: 'Zona',
  amount: 'Precio',
  rate: 'Tarifa',
  conditionExpression: 'Cálculo',
  feeFactor: 'Factor de tarifa',
  continuedPrice: 'Precio por peso adicional',
  continuedWeight: 'Peso adicional (g)',
  firstPrice: 'Precio por primer peso',
  firstWeight: 'Primer peso (g)',
  weightRangeStart: 'Peso inicial (g)',
  weightRangeEnd: 'Peso final (g)',
  holder: {
    toCountry: 'Elegir destino',
    inputWeight: 'Por favor, ingrese el peso',
    selectCountry: 'Por favor, seleccione un país',
    selectCarrier: 'Por favor, seleccione un transportista/línea de transportista/país de ruta',
    selectCategory: 'Elegir restricción de envío',
  },
  typeDelivery: 'Tipos de entrega',
  shippingTime: 'Tiempo estimado de envío',
  workDay: 'días laborables',
  deliveryTips: 'Consejos de envío',
  estimatedShippingFee: 'Tarifa de envío estimada',
  lineServiceTips:
    'Nota: Todos los servicios logísticos para rutas no propias de acbuy son proporcionados por proveedores logísticos terceros, quienes ajustarán los precios de flete según las condiciones del mercado. En caso de cualquier cambio de precio, acbuy le notificará con anticipación. Si encuentra algún problema con los servicios logísticos, acbuy puede comunicarse con el proveedor logístico tercero en su nombre.',
  logisticsStatement: '<Declaración de servicio logístico>',
  customizedDelivery: 'Servicio de entrega personalizado',
  customizedDeliveryText:
    'Distribución a granel, transporte marítimo y ferroviario, puede optar por servicios de distribución personalizados',
  customizeNow: 'Ahora personalizado',
  declareAmountRange: 'Alcance del monto declarado',
  viewUnavailableLines: 'Ver líneas desactivadas (desactivadas:',
  'i18n-0000001': 'Tarifa de entrega',
  'i18n-0000002':
    'Para todos los paquetes enviados entre el {timeStart} y el {timeEnd}, el porcentaje de paquetes que se han entregado hasta hoy',
  'i18n-0000003': 'días',
  couponDiscount: 'Descuento del cupón',
  expectedDiscount: 'Descuento esperado',
}
